const theme = {
  themes: {
    dark: {
      primary: '#00A65A',
      accent: '#FF4081',
      secondary: '#1E282C',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FB8C00',
      error: '#FF5252'
    },
    light: {
      primary: '#00A65A',
      accent: '#e91e63',
      secondary: '#1E282C',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FB8C00',
      error: '#FF5252'
    }
  }
};

export default theme;
